import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useDialog } from '../hooks';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const DialogComponent = () => {
    const [dialog, setDialog] = useDialog();
    const { open, content } = dialog;

    const dialogOutput = (
        <Dialog aria-labelledby="copon dialog" open={open} TransitionComponent={Transition}
            keepMounted onClose={()=>{setDialog({ ...dialog, open: false });}}>
            {content}
        </Dialog>
    );

    return <React.Fragment>{dialogOutput}</React.Fragment>;
}

export default DialogComponent;
